import React from 'react';
import { Box, Typography, Avatar, Chip } from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import EmailIcon from '@mui/icons-material/Email';
import PersonIcon from '@mui/icons-material/Person';
import { getAllInstructors, deleteInstructor } from '../../api/instructorApi';
import { GenericListPage } from '../../components/templates';

const InstructorList = () => {
  const columns = [
    {
      field: 'name',
      headerName: 'Instructor Name',
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Avatar
            sx={{
              backgroundColor: 'primary.main',
              width: 32,
              height: 32,
              fontSize: '0.875rem',
            }}
          >
            <PersonIcon sx={{ fontSize: '1rem' }} />
          </Avatar>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {params.value}
          </Typography>
        </Box>
      ),
    },
    {
      field: 'email',
      headerName: 'Email Address',
      flex: 1.2,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <EmailIcon sx={{ fontSize: '1rem', color: 'text.secondary' }} />
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {params.value}
          </Typography>
        </Box>
      ),
    },
    {
      field: 'course',
      headerName: 'Course',
      flex: 1,
      renderCell: (params) => (
        <Chip
          label={params.value || 'No Course Assigned'}
          color={params.value ? 'success' : 'default'}
          size="small"
          variant="outlined"
          sx={{ fontWeight: 500 }}
        />
      ),
    },
    {
      field: 'description',
      headerName: 'Description',
      flex: 1.5,
      renderCell: (params) => (
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: '200px',
          }}
        >
          {params.value || 'No description provided'}
        </Typography>
      ),
    },
  ];

  return (
    <GenericListPage
      title="Instructor Management"
      subtitle="Manage instructors and their course assignments"
      icon={<SchoolIcon />}
      entityName="Instructor"
      columns={columns}
      fetchData={getAllInstructors}
      deleteItem={deleteInstructor}
      createPath="/instructors/new"
      editPath="/instructors"
    />
  );
};

export default InstructorList;
